<template>

</template>

<script>
export default {
    name: "SalesAssignment.vue"
}
</script>

<style scoped>

</style>
